app.filter("medical", function($sce, odmRecommendService) {
	return function (msgdata) {
		var htmlstr = "";
		var dmEnables = odmRecommendService.getMsgEnables();
		if( msgdata != null ) {
			var enablecnt = 0;
			for( var i = 0; i < msgdata.length; i++ ) {
                if( dmEnables[msgdata[i].category] ) {
					htmlstr += msgdata[i].message + "<br/>";
					enablecnt++;
				}
            };
			if( enablecnt == 0 ) {
				htmlstr = "入力された項目が少ないため医師から回答が得られませんでした。<br/>より多くの項目を入力することでより正確な回答が得られます。";
			}
		}
		return $sce.trustAsHtml( htmlstr );
	};
});
